import clsx from 'clsx';
import { useEllipsizedText } from '../../hooks';
import { Tooltip } from '../tooltip';

const DEFAULT_TOOLTIP_PROPS = {
  bubbleAlign: 'center',
  wrap: 'normal',
  bubbleWidthPx: 320,
  followCursor: true,
  showArrow: false,
};

export function EllipsizedText({
  as: Component = 'span',
  className,
  truncatedClassName,
  triggerClassName,
  maxHeightPx,
  tooltipContent,
  tooltipProps,
  children,
  ...rest
}) {
  const { ref, text, isTruncated } = useEllipsizedText({
    text: String(children ?? ''),
    maxHeightPx,
  });
  const content = isTruncated ? (tooltipContent ?? children) : null;

  return (
    <Tooltip
      {...DEFAULT_TOOLTIP_PROPS}
      {...tooltipProps}
      content={content}
      triggerClassName={clsx(triggerClassName)}
    >
      <Component ref={ref} className={clsx(className, isTruncated && truncatedClassName)} {...rest}>
        {text}
      </Component>
    </Tooltip>
  );
}
